import { Grid, useEventCallback } from '@mui/material';
import { Form, Formik } from 'formik';
import ModalInfoCertification from 'front-office/components/shared/info-certificate';
import ModalCertificate from 'front-office/components/authentic/request-certificate-modal';
import ModalPrintSuccess from 'front-office/components/shared/request-print';
import { Fragment, useCallback, useState } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import * as yup from 'yup';
import { AuthenticFormVM } from 'front-office/view-models/authentic/authentic-form';
import { AuthenticCrumbs } from 'front-office/constants/authentic-crumbs';
import AuthenticForm from 'front-office/components/authentic';
import { HttpResponse } from 'shell/models/http-response';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
// import { openPdf } from 'shell/utils/open-pdf';
import { ResponseCertificateGeneric } from 'shell/models/response-certificate-generic';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { transformRequestAuthenticData } from 'front-office/utils/transform-request-authentic';
import { transformResponseRequestCertificateGeneric } from 'front-office/utils/transform-response-certificate-generic';
import { validationCertificationSchema } from 'front-office/constants/validation-shema/certification-schema';
import PageButtons from 'front-office/components/shared/buttons-certificate';
import { CommonRequestCertificateInterface } from 'front-office/view-models/common-certificate-form';
import { ModalViewerPDF } from 'shell/components/shared/pdf-modal';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import { DocumentRadioCertificate } from 'front-office/constants/document-radio-certificate';
import PmiTitle from 'shell/components/shared/title';

// Crea una copia di validationCertificationSchema
const tempSchema = { ...validationCertificationSchema };
// Elimina la chiave 'accountholder' dalla copia
delete tempSchema.accountholder;

// Ora restSchema contiene tutte le proprietà tranne 'accountholder'
const restSchema = tempSchema;

const validationSchema = yup
  .object()
  .shape({
    ...restSchema,
  })
  .test('', '', () => {
    // const valuesCasted = values as unknown as AuthenticFormVM;

    // // same as applicant
    // if (valuesCasted?.accountholder?.sameApplicant) {
    //   if (!valuesCasted?.certifiableApplicant) {
    //     return new yup.ValidationError(
    //       'Soggetto non certificabile',
    //       undefined,
    //       'certifiableApplicant'
    //     );
    //   }
    // } else {
    //   if (!valuesCasted?.accountholder?.certifiableAccountholder) {
    //     return new yup.ValidationError(
    //       'Soggetto non certificabile',
    //       undefined,
    //       'certifiableAccountholder'
    //     );
    //   }
    // }

    return true;
  });

const AuthenticPage = (): React.ReactElement => {
  const [certificatePdf, getPdfCertificate] = useHttpFetch<
    HttpResponse<ResponseCertificateGeneric>,
    HttpResponse<ResponseCertificateGeneric>
  >(`${__CERTIFICATION_API_URL__}/richiesta-certificato/generico`, {
    onBootstrap: false,
    options: {
      method: 'POST',
    },
    transformer: transformResponseRequestCertificateGeneric,
  });

  const { userProfile } = useUserProfile();
  const cashManagement = userProfile?.datiLogin?.profile?.servizio?.gestioneCassa;

  // Casted response certificate
  const dataCertificate = certificatePdf.data as HttpResponse<ResponseCertificateGeneric>;

  // ModalCertificate
  const [open, setOpen] = useState<boolean>(false);

  // ModalPrintSuccess
  const [modalPrintSuccess, setModalPrintSuccess] = useState<{ open: boolean; total?: number }>({
    open: false,
  });

  // InfoCertification
  const [infoCertification, setInfoCertification] = useState<{ open: boolean; total?: number }>({
    open: false,
  });

  const [pdfModal, setPdfModal] = useState({ data: '', open: false, name: '' });

  // Handle the submit
  const handleSubmit = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const onRequestCertificate = useEventCallback(
    (values: AuthenticFormVM, setFieldValue: (key: string, value: number) => void) => {
      const data = transformRequestAuthenticData(values);

      (
        getPdfCertificate({ data }) as ResponsePromise<
          HttpResponse<ResponseCertificateGeneric>,
          HttpResponse<ResponseCertificateGeneric>
        >
      ).then((response) => {
        const responseCasted = response as HttpResponse<ResponseCertificateGeneric>;
        const pdfCertificate = responseCasted?.payload?.contenutoPdfCertificato;

        const { modality } = values;

        const {
          amountRightsSecretariat = 0.0,
          amountRightsCivilState = 0.0,
          amountFixedRights = 0.0,
          amountExpenses = 0.0,
          amountTaxStamp = 0.0,
        } = modality || {};

        const numberFace = values.numberFacades ? Number.parseFloat(values.numberFacades) : 0;
        const numberFaceDivided = numberFace / 4;

        const numberFacesCasted = numberFace % 4 >= 1 ? numberFaceDivided + 1 : numberFaceDivided;

        const taxStampWithNumberFace = values.numberFacades
          ? Number.parseInt(numberFacesCasted.toString()) * amountTaxStamp
          : 0;

        // se AU01 allora amountTaxStamp altrimenti con numero facciate
        const taxStamp =
          values.authentics?.key.codiceDocumento === '1' ? amountTaxStamp : taxStampWithNumberFace;

        const rights =
          amountExpenses +
          amountFixedRights +
          amountRightsCivilState +
          amountRightsSecretariat +
          taxStamp;

        // close ModalCertificate
        setOpen(false);

        if (pdfCertificate) {
          // openPdf(pdfCertificate);
          setPdfModal({ data: pdfCertificate, name: 'Autentica', open: true });
        }

        const parsedTotal = values?.certificateInternOnly
          ? Number.parseFloat('0,00')
          : Number.parseFloat(rights?.toString() || '0,00');

        if (values.authentics?.key.codiceDocumento !== '1') {
          const total = (values?.payment || 0) + parsedTotal;

          setFieldValue('payment', total);

          //open ModalPrintSuccess
          setInfoCertification({ open: true, total: parsedTotal });

          return;
        }

        setModalPrintSuccess({ open: false, total: parsedTotal });
      });
    }
  );

  const onYes = useEventCallback(
    (
      values: CommonRequestCertificateInterface,
      setFieldValue: (
        key: keyof CommonRequestCertificateInterface,
        value: CommonRequestCertificateInterface[keyof CommonRequestCertificateInterface]
      ) => void
    ) => {
      const total = (values?.payment || 0) + (modalPrintSuccess?.total || 0);

      setFieldValue('payment', total);

      // close ModalPrintSuccess
      setModalPrintSuccess({ open: false, total: undefined });

      //open InfoCertification
      setInfoCertification({ open: true, total: modalPrintSuccess.total });
    }
  );

  return (
    <Fragment>
      <Breadcrumbs items={AuthenticCrumbs} base="sportello" />
      <div>
        <PmiTitle title="Autentiche" />
      </div>
      <div className="pmi-mt-4">
        <div className="pmi-mt-2">
          <Formik
            validationSchema={validationSchema}
            initialValues={
              {
                accountholder: {
                  sameApplicant: true,
                  account: {
                    generality: {
                      isForeignDocument: DocumentRadioCertificate.IdentityCard,
                    },
                  },
                },
                payment: 0,
                certificateInternOnly: cashManagement !== 'S' ? true : false,
                intendedUse: '0',
                generality: {
                  isForeignDocument: DocumentRadioCertificate.IdentityCard,
                },
              } as AuthenticFormVM
            }
            onSubmit={(values, context) => onRequestCertificate(values, context.setFieldValue)}
            validateOnChange
            validateOnBlur
            validateOnMount
          >
            <Form>
              <Grid container spacing={1}>
                <Grid item xs={12} md={3}>
                  <PageButtons handleRequestCertificate={handleSubmit} label="Autentica" />
                </Grid>
                <Grid item xs={12} md={9}>
                  <div className="pmi-px-md-4">
                    <AuthenticForm />
                  </div>
                </Grid>
              </Grid>
              <ModalCertificate open={open} onClose={setOpen} />
              <ModalPrintSuccess
                open={modalPrintSuccess.open}
                onClose={() => setModalPrintSuccess({ open: false })}
                onYes={onYes}
              />
              <ModalInfoCertification
                open={infoCertification.open}
                onClose={() => setInfoCertification({ open: false })}
                title={dataCertificate?.payload?.numeroIdentificativoDocumento}
                amountCertifate={infoCertification.total?.toFixed(2)}
              />
              <ModalViewerPDF
                open={pdfModal.open}
                data={pdfModal.data}
                name={pdfModal.name}
                title="Certificazione"
                onClose={() => {
                  setPdfModal({ data: '', open: false, name: '' });
                  setModalPrintSuccess((oldState) => ({ ...oldState, open: true }));
                }}
              />
            </Form>
          </Formik>
        </div>
      </div>
    </Fragment>
  );
};

AuthenticPage.displayName = 'Authentic page';

export default AuthenticPage;
